// extracted by mini-css-extract-plugin
export default {"sectionTitle":"SectionTitle_sectionTitle__1A60h"};